// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var Caml_option = require("rescript/lib/js/caml_option.js");
var ReactRelay = require("react-relay");
var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
var RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

function makeRefetchVariables() {
  
}

var Types = {
  makeRefetchVariables: makeRefetchVariables
};

function unwrap_response_sessionV5_authenticatedUserV2_value(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["Agent"]);
}

var variablesConverter = {};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

var wrapResponseConverter = {"__root":{"sessionV5_authenticatedUserV2_value_Agent":{"f":""},"sessionV5_authenticatedUserV2_value":{"u":"response_sessionV5_authenticatedUserV2_value"}}};

var wrapResponseConverterMap = {
  response_sessionV5_authenticatedUserV2_value: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

var responseConverter = {"__root":{"sessionV5_authenticatedUserV2_value_Agent":{"f":""},"sessionV5_authenticatedUserV2_value":{"u":"response_sessionV5_authenticatedUserV2_value"}}};

var responseConverterMap = {
  response_sessionV5_authenticatedUserV2_value: unwrap_response_sessionV5_authenticatedUserV2_value
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

var Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

var Utils = {};

var node = ((function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserSessionPermissionsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SessionV5",
        "kind": "LinkedField",
        "name": "sessionV5",
        "plural": false,
        "selections": [
          {
            "kind": "CatchField",
            "field": {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "authenticatedUserV2",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "UserSessionPermissions_permissions"
                    }
                  ],
                  "type": "Agent",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            },
            "to": "RESULT"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "UserSessionPermissionsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SessionV5",
        "kind": "LinkedField",
        "name": "sessionV5",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "authenticatedUserV2",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "permissions",
                    "storageKey": null
                  }
                ],
                "type": "Agent",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "nodeId",
                    "storageKey": null
                  }
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "13db44382ab4804f0bb32121f63f7454",
    "id": null,
    "metadata": {},
    "name": "UserSessionPermissionsQuery",
    "operationKind": "query",
    "text": "query UserSessionPermissionsQuery {\n  sessionV5 {\n    authenticatedUserV2 {\n      __typename\n      ... on Agent {\n        ...UserSessionPermissions_permissions\n      }\n      ... on Node {\n        __isNode: __typename\n        __typename\n        nodeId\n      }\n    }\n  }\n}\n\nfragment UserSessionPermissions_permissions on Agent {\n  permissions\n}\n"
  }
};
})());

function load(environment, variables, fetchPolicy, fetchKey, networkCacheConfig) {
  return ReactRelay.loadQuery(environment, node, convertVariables(variables), {
              fetchKey: fetchKey,
              fetchPolicy: fetchPolicy,
              networkCacheConfig: networkCacheConfig
            });
}

function queryRefToObservable(token) {
  return Caml_option.nullable_to_opt(token.source);
}

function queryRefToPromise(token) {
  return new Promise((function (resolve, param) {
                var o = queryRefToObservable(token);
                if (o !== undefined) {
                  Caml_option.valFromOption(o).subscribe({
                        complete: (function () {
                            resolve({
                                  TAG: "Ok",
                                  _0: undefined
                                });
                          })
                      });
                  return ;
                } else {
                  return resolve({
                              TAG: "Error",
                              _0: undefined
                            });
                }
              }));
}

var wrap_response_sessionV5_authenticatedUserV2_value = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_sessionV5_authenticatedUserV2_value = unwrap_response_sessionV5_authenticatedUserV2_value;
exports.wrap_response_sessionV5_authenticatedUserV2_value = wrap_response_sessionV5_authenticatedUserV2_value;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
exports.load = load;
exports.queryRefToObservable = queryRefToObservable;
exports.queryRefToPromise = queryRefToPromise;
/* node Not a pure module */
